@if (user()) {
  <app-join-social-home />
}
